// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { TvIcon } from '@10xLabs/react-web/components/Icons/Tv'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { PlugIcon } from '@10xLabs/react-web/components/Icons/Plug'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { WomanSeatIcon } from '@10xLabs/react-web/components/Icons/WomanSeat'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { WomenIcon } from '@10xLabs/react-web/components/Icons/Women'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { MenIcon } from '@10xLabs/react-web/components/Icons/Men'
import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'
import { SEAT_PROPERTIES, WC_PROPERTIES } from 'features/VehicleTemplates/components/Properties/constants'

const SeatPropertyIcon = ({ property, ...props }: TSFixMe): TSFixMe => {
  switch (property) {
    case SEAT_PROPERTIES.TV:
      return <TvIcon {...props} />
    case SEAT_PROPERTIES.PLUG:
      return <PlugIcon {...props} />
    case SEAT_PROPERTIES.WOMEN:
      return <WomanSeatIcon {...props} />
  }

  return null
}

const WcPropertyIcon = ({ property, ...props }: TSFixMe): TSFixMe => {
  switch (property) {
    case WC_PROPERTIES.WOMEN:
      return <WomenIcon {...props} />
    case WC_PROPERTIES.MEN:
      return <MenIcon {...props} />
  }

  return null
}

export const PropertyIcon = ({ component, property, ...props }: TSFixMe): TSFixMe => {
  switch (component) {
    case VEHICLE_COMPONENT.SEAT:
      return <SeatPropertyIcon property={property} {...props} />
    case VEHICLE_COMPONENT.WC:
      return <WcPropertyIcon property={property} {...props} />
  }

  return null
}
